import { render, staticRenderFns } from "./SignIdentityState.vue?vue&type=template&id=6c0896bb&scoped=true"
import script from "./SignIdentityState.vue?vue&type=script&setup=true&lang=js"
export * from "./SignIdentityState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SignIdentityState.vue?vue&type=style&index=0&id=6c0896bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0896bb",
  null
  
)

export default component.exports